import { RemoteExportPerformanceReportForProfessionalsExcel } from 'data/usecases';
import { ExportPerformanceReportForProfessionalsExcelUseCaseInterface } from 'domain/usecases';
import { makeApiUrlPerformanceReportForProfessionalsExcel } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeExportPerformanceReportForProfessionalsExcel =
  (): ExportPerformanceReportForProfessionalsExcelUseCaseInterface =>
    new RemoteExportPerformanceReportForProfessionalsExcel(
      makeApiUrlPerformanceReportForProfessionalsExcel(),
      makeAxiosHttpClient(),
    );
